import React, { useRef, useCallback, useContext, useEffect } from 'react';
import Webcam from 'react-webcam';
import CnoPhotoContext from '../contexts/CnoPhotoContext';
import { Button, Container } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { BottomNav } from './BottomNav';



const WebcamCapture = (props) => {

    const webcamRef = useRef(null);
    const { cnoPhoto, setCnoPhoto } = useContext(CnoPhotoContext);

    const capture = useCallback(() => {
        const imageSource = webcamRef.current.getScreenshot();
        setCnoPhoto(imageSource);
    }, [webcamRef, setCnoPhoto]);

    useEffect(() => {
        console.log("useEffect in WebcamCapture");
        if (cnoPhoto) {
            console.log("set dialog open");
            props.setDialogOpen();
        }
    }, [cnoPhoto]);

    // if (cnoPhoto) {
    //     return (
    //         <React.Fragment>
    //             <img src={cnoPhoto} alt="container not out" />
    //             <p>
    //                 <Button variant="contained" color="primary" onClick={capture}>Retake Photo</Button>
    //                 <Button variant="contained" color="primary" onClick={props.handleClick}>Save Photo</Button>
    //             </p>
    //         </React.Fragment>
    //     );
    // }

    const videoConstraints = {
        facingMode: { exact: "environment" }
    };

    if (isMobile) {
        return (
            <Container>
                <Webcam
                    className={"webcam-container"}
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    videoConstraints={videoConstraints}
                />
                <BottomNav>
                    <Button component="a" color="primary" onClick={capture}>Take Photo</Button>
                </BottomNav>
            </Container>
        );
    } else {
        return (
            <Container>
                <Webcam
                    className={"webcam-container"}
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                />
                <BottomNav>
                    <Button component="a" color="primary" onClick={capture}>Take Photo</Button>
                </BottomNav>
            </Container>
        );
    }
};

export default WebcamCapture;